import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { MdOutlineBlock, MdSearch, MdMode, MdDelete, MdRemoveRedEye, MdDownload, MdClose } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Sort from '../../assets/image/sort-down-alt.svg';
import Filter from '../../assets/image/filter.svg';
import Dummy from '../../assets/image/user-circle.svg';
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import fileCSV from '../../assets/File/Coach.xlsx'
import demppic from "../../assets/image/user-circle.svg"
import Loader from '../../Components/Loader/Loader';

function TotalSessionProgress() {


    const [totalPages, setTotalPages] = useState(0)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [indexNumber, setIndexNumber] = useState(0)

    const [id, setId] = useState(0);
    const [user, setUser] = useState([]);

    const [block, setBlock] = useState(false);
    const blockClose = () => setBlock(false);
    const [delet, setDelet] = useState(false);
    const deleteClose = () => setDelet(false);
    const location = useLocation()
    const [search, setSearch] = useState("");


    const navigate = useNavigate();
    useEffect(() => {
        getUserList()
    }, [])
    const paginationHandler = (e, i) => {
        e.preventDefault();
        console.log("iiii", i);
        if (i != page) {
            setPage(i);
            const newIndexNumber = perPage * (i - 1); // Calculate starting index for the page
            setIndexNumber(newIndexNumber);
            // CcrApiList({
            //     ...searchQuery,
            //     page: i,
            //     limit: perPage
            // })
        }
    };
    const getUserList = async () => {
        const response = await handleApiCall("get", `${endpoint.totalsessionProgress}?page=${page}&limit=${perPage}&id=${location?.state?.coach?._id}${location?.state?.filter}`, {});
        try {
            console.log(response, "DataaaProgress")
            if (response?.data?.code === 200) {
                setUser(response?.data?.data?.schoolData);

                setTotalPages(response?.data?.data?.total_pages);
                setTotal(response?.data?.data?.total);
            }
            if (response?.response?.data?.success === false) {
             
                toast.error(response?.response?.data?.errorMessage);
                setTimeout(() => { navigate("/") }, 2000);
            }
        } catch (e) {
            console.log("Error fetching data:", e);
        }
    };

    const goBack = () => {
        navigate(-1); // Navigates back to the previous page

    };
 

    return (
        <>
            <div className=' flex gap-2 items-center'>
                <img src={location?.state?.coach?.image || demppic} alt="user" className="w-16 h-16 rounded-full" />
                <div className=' flex-col'>
                    <p className=' font-bold '>  {location?.state?.coach?.full_name} </p>

                </div>
            </div>
            <div className="common-table-wrapper m-0 ">

                <div className=" my-3">
                    <div className='flex-col gap-2 justify-start items-center'>
                        <h2 className=' mr-5 text-[30px]'>{""}</h2>

                    </div>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-8 sm:grid-cols-3 gap-3 my-2 ">


                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Region</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.region_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Country</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.country_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">State</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.state_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Dstrict</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.district_name || "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Block</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.block_name || "-"}</span>
                    </div>

                </div>
                <div className=' flex  justify-between my-3 mt-5'>
                    <Link onClick={goBack} className="text-white bg-black hover:text-white outline-1 outline-double rounded-md text-sm font-semibold px-4 py-2 d-inline-block">Back</Link>

                </div>
                <div className=' grid  md:grid-cols-2 gap-3 my-2  '>
                    {user?.map(item => {
                        return (<div className='bg-[#E5DED4] bg-opacity-25 p-4 rounded-md'>
                            <div className=' flex justify-between'>
                                <div>
                                    <p className='text-center text-[14px] font-bold text-wrap break-words'>{item?.school_name}</p>
                                    <p className=' text-center text-[12px]  text-gray-500 font-semibold text-wrap break-words'>{item?.school_address}</p>
                                </div>
                                <div>
                                    <p className='text-[11px] text-gray-500' >{item?.completedObservation + "/" + item?.totalObservation}</p>
                                </div>
                            </div>
                            <div className=" overflow-x-auto mt-3">
                                <div className="flex gap-4 min-w-max mb-2">

                                    <div className="flex gap-4 min-w-max mb-2">
                                        {item?.teacherData?.length > 0 ? (
                                            item.teacherData.map((teacher, idx) => (
                                                <div
                                                    key={idx}
                                                    className="p-3 bg-[#F0E4E5] rounded-md w-36 flex-shrink-0 text-center"
                                                >
                                                    <div className="flex justify-center">
                                                        <img
                                                            src={teacher?.image || demppic}
                                                            alt="user"
                                                            className="w-5 h-5 rounded-full"
                                                        />
                                                    </div>
                                                    <p className="mt-1 text-[12px] font-bold break-words">
                                                        {teacher?.full_name}
                                                    </p>
                                                    <p className="text-[11px] text-gray-500">
                                                        {teacher?.completedObservation + "/" + teacher?.totalObservation}
                                                    </p>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="p-3 bg-[#F0E4E5] rounded-md w-36 flex-shrink-0 text-center">
                                                <div className="flex justify-center">
                                                    <img src={demppic} alt="user" className="w-5 h-5 rounded-full" />
                                                </div>
                                                <p className="mt-1 text-[12px] font-bold break-words">No Teacher Found</p>
                                                <p className="text-[11px] text-gray-500">0/0</p>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>)
                    })}


                </div>

            </div>

        </>
    )
}

export default TotalSessionProgress